import { render } from "./Codici.vue?vue&type=template&id=7ce48ec0"
import script from "./Codici.vue?vue&type=script&lang=ts"
export * from "./Codici.vue?vue&type=script&lang=ts"
script.render = render

export default script